import { useEffect, useRef, useState } from 'react'
import {
  FaShieldHalved,
  FaServer,
  FaHeadset,
  FaBolt,
  FaArrowRight,
  FaPlay,
} from 'react-icons/fa6'
import useNetworkCanvas from '../../../hooks/useNetworkCanvas'
import DashboardMockup from '../../../hooks/useDashboardMockup'
import { Link } from 'react-router-dom'

const badges = [
  { icon: FaShieldHalved, text: 'Data Terenkripsi' },
  { icon: FaServer, text: 'Uptime 99.9%' },
  { icon: FaHeadset, text: 'Support 24/7' },
  { icon: FaBolt, text: 'Setup 5 Menit' },
]

export default function LpHeroSection({accessToken}) {

  const canvasRef = useRef(null)
  useNetworkCanvas(canvasRef)

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Network Canvas */}
      <canvas
        ref={canvasRef}
        id="network-canvas"
        className="absolute top-0 left-0 w-full h-full z-0"
        aria-hidden="true"
      />

      {/* Gradient Orbs */}

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 lg:py-0 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Kiri: Copy */}
          <div>
            <div
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-ocean-800/15 border border-ocean-600/25 mb-8"
              style={{ animation: 'fadeIn 1s ease-out' }}
            >
              <span className="w-2 h-2 rounded-full bg-ocean-500 animate-pulse" />
              <span className="text-ocean-400 text-sm font-medium">
                Billing System Terdepan untuk ISP Indonesia
              </span>
            </div>

            <h1
              className="font-display text-xl sm:text-2xl md:text-3xl lg:4xl font-bold leading-[1.1] mb-6"
              style={{ animation: 'slideUp .9s ease-out' }}
            >
              Kelola ISP Anda dengan{' '}
              <span className="gradient-text">Sistem Billing</span> yang Handal
            </h1>

            <p
              className=" text-slate-custom leading-relaxed mb-10 max-w-xl"
              style={{ animation: 'slideUp .9s ease-out .15s both' }}
            >
              Radius Trend mempermudah pengelolaan pelanggan, tagihan otomatis,
              monitoring jaringan, dan integrasi Mikrotik untuk RT/RW Net
              maupun ISP skala besar.
            </p>

            <div
              className="flex flex-wrap gap-4"
              style={{ animation: 'slideUp .9s ease-out .3s both' }}
            >
              {accessToken ? (
                <Link to={'/dashboard-menu'} className="btn-primary">
                  <span>Masuk Sekarang</span>
                  <FaArrowRight className="text-sm" />
                </Link>
              ) : (
                <Link to={'/login'} className="btn-primary">
                  <span>Mulai Gratis 14 Hari</span>
                  <FaArrowRight className="text-sm" />
                </Link>
              )}
              <a href="#fitur" className="btn-secondary">
                <FaPlay className="text-sm" />
                <span>Lihat Fitur</span>
              </a>
            </div>

            <div
              className="flex flex-wrap items-center gap-x-8 gap-y-3 mt-12 pt-8 border-t border-navy-500/40"
              style={{ animation: 'slideUp .9s ease-out .45s both' }}
            >
              {badges.map((b, i) => {
                const Icon = b.icon
                return (
                  <div key={i} className="flex items-center gap-2">
                    <Icon className="text-ocean-700 text-sm" />
                    <span className="text-sm text-slate-custom">{b.text}</span>
                  </div>
                )
              })}
            </div>
          </div>

          {/* Kanan: Dashboard Mockup */}
          <div
            className="hidden lg:block"
            style={{ animation: 'fadeIn 1.2s ease-out .5s both' }}
          >
            <DashboardMockup />
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 rounded-full border-2 border-ocean-600/40 flex justify-center pt-2">
          <div className="w-1 h-3 bg-ocean-500 rounded-full animate-pulse" />
        </div>
      </div>
    </section>
  )
}